import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxAdvancePaginationComponent } from './ngx-advance-pagination.component';

@NgModule({
  declarations: [
    NgxAdvancePaginationComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    NgxAdvancePaginationComponent
  ]
})
export class NgxAdvancePaginationModule { }
